import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key: 'searchcustomers',
  path: '/search-customers',
  title: 'Search Customers',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);